/**
 * @generated SignedSource<<5625e191d8bf621f884ac56fe782aed1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SiteEditFormContainer_Query$variables = {
  siteSlug: string;
};
export type SiteEditFormContainer_QueryVariables = SiteEditFormContainer_Query$variables;
export type SiteEditFormContainer_Query$data = {
  readonly site: {
    readonly id: string;
    readonly name: string;
    readonly url: string;
    readonly slug: string;
  };
};
export type SiteEditFormContainer_QueryResponse = SiteEditFormContainer_Query$data;
export type SiteEditFormContainer_Query = {
  variables: SiteEditFormContainer_QueryVariables;
  response: SiteEditFormContainer_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteSlug"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "siteSlug"
      }
    ],
    "concreteType": "Site",
    "kind": "LinkedField",
    "name": "site",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SiteEditFormContainer_Query",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SiteEditFormContainer_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3ad9a331a800c89401e885b435ae4af1",
    "id": null,
    "metadata": {},
    "name": "SiteEditFormContainer_Query",
    "operationKind": "query",
    "text": "query SiteEditFormContainer_Query(\n  $siteSlug: String!\n) {\n  site(slug: $siteSlug) {\n    id\n    name\n    url\n    slug\n  }\n}\n"
  }
};
})();

(node as any).hash = "a75987f308169053b41f5ff5ce2eb779";

export default node;
